import React from 'react';

interface AiTextRendererProps {
    text: string;
    /** When false, `**bold**` markers are dropped and their words render at the surrounding weight. */
    bold?: boolean;
    /** Bold passages that render at the surrounding weight anyway — matched whole, ignoring case and spacing. */
    unboldTerms?: string[];
}

const normalize = (value: string) => value.trim().toLocaleLowerCase();

function renderSegments(text: string, bold: boolean, unboldTerms: Set<string>): React.ReactNode[] {
    const parts = text.split(/(\*{1,3}[^*]+\*{1,3})/g);
    return parts.map((part, index) => {
        const boldItalicMatch = /^\*{3}(.+)\*{3}$/.exec(part);
        if (boldItalicMatch) {
            const isBold = bold && !unboldTerms.has(normalize(boldItalicMatch[1]));
            return <span key={index} className={isBold ? 'font-semibold italic' : 'italic'}>{boldItalicMatch[1]}</span>;
        }
        const boldMatch = /^\*{2}(.+)\*{2}$/.exec(part);
        if (boldMatch) {
            const isBold = bold && !unboldTerms.has(normalize(boldMatch[1]));
            return isBold ? <span key={index} className="font-semibold">{boldMatch[1]}</span> : boldMatch[1];
        }
        const italicMatch = /^\*(.+)\*$/.exec(part);
        if (italicMatch) {
            return <span key={index} className="italic">{italicMatch[1]}</span>;
        }
        return part;
    });
}

export const AiTextRenderer: React.FC<AiTextRendererProps> = ({ text, bold = true, unboldTerms = [] }) => {
    return <span>{renderSegments(text, bold, new Set(unboldTerms.map(normalize)))}</span>;
};
